import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-45cde246")

_pushScopeId("data-v-45cde246")
const _hoisted_1 = { class: "answer-container" }
const _hoisted_2 = { class: "cover-wrapper" }
const _hoisted_3 = { class: "detail-title" }
const _hoisted_4 = { class: "detail-image" }
const _hoisted_5 = { class: "form-item" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", null, "收货人", -1)
const _hoisted_7 = {
  key: 1,
  class: "no-length"
}
const _hoisted_8 = { class: "form-item" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", null, "手机号码", -1)
const _hoisted_10 = {
  key: 1,
  class: "no-length"
}
const _hoisted_11 = { class: "form-item" }
const _hoisted_12 = /*#__PURE__*/_createVNode("span", null, "所在地区", -1)
const _hoisted_13 = {
  key: 1,
  class: "no-length"
}
const _hoisted_14 = { class: "form-item" }
const _hoisted_15 = /*#__PURE__*/_createVNode("span", null, "详细地址", -1)
const _hoisted_16 = {
  key: 1,
  class: "no-length"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Title = _resolveComponent("Title")
  const _component_Back = _resolveComponent("Back")
  const _component_Action = _resolveComponent("Action")
  const _component_van_area = _resolveComponent("van-area")
  const _component_van_popup = _resolveComponent("van-popup")
  const _component_PopInner = _resolveComponent("PopInner")

  return (_openBlock(), _createBlock(_component_PopInner, {
    circleRight: true,
    circleTop: true,
    flower: true,
    spot: true,
    starTop: true,
    starMiddle: true
  }, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_Title, { text: `奖品兑换` }),
        _createVNode(_component_Back, { onAction: _ctx.goBack }, null, 8, ["onAction"]),
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("span", null, _toDisplayString(_ctx.data.name), 1)
          ]),
          _createVNode("div", _hoisted_4, [
            _createVNode("img", {
              src: _ctx.data.img
            }, null, 8, ["src"])
          ]),
          _createVNode("div", _hoisted_5, [
            _hoisted_6,
            (_ctx.data.isActive)
              ? _withDirectives((_openBlock(), _createBlock("input", {
                  key: 0,
                  placeholder: "请填写收货人姓名",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.name = $event))
                }, null, 512)), [
                  [_vModelText, _ctx.name]
                ])
              : _createCommentVNode("", true),
            (!_ctx.data.isActive)
              ? (_openBlock(), _createBlock("span", _hoisted_7, _toDisplayString(_ctx.data.user_name), 1))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_8, [
            _hoisted_9,
            (_ctx.data.isActive)
              ? _withDirectives((_openBlock(), _createBlock("input", {
                  key: 0,
                  placeholder: "请填写联系人手机号码",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.mobile = $event))
                }, null, 512)), [
                  [_vModelText, _ctx.mobile]
                ])
              : _createCommentVNode("", true),
            (!_ctx.data.isActive)
              ? (_openBlock(), _createBlock("span", _hoisted_10, _toDisplayString(_ctx.data.phone), 1))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_11, [
            _hoisted_12,
            (_ctx.data.isActive)
              ? (_openBlock(), _createBlock("span", {
                  key: 0,
                  class: "span-area",
                  onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showArea && _ctx.showArea(...args)), ["stop","prevent"]))
                }, _toDisplayString(_ctx.area), 1))
              : _createCommentVNode("", true),
            (!_ctx.data.isActive)
              ? (_openBlock(), _createBlock("span", _hoisted_13, _toDisplayString(_ctx.data.region), 1))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_14, [
            _hoisted_15,
            (_ctx.data.isActive)
              ? _withDirectives((_openBlock(), _createBlock("input", {
                  key: 0,
                  placeholder: "街道，楼牌号等",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.address = $event))
                }, null, 512)), [
                  [_vModelText, _ctx.address]
                ])
              : _createCommentVNode("", true),
            (!_ctx.data.isActive)
              ? (_openBlock(), _createBlock("span", _hoisted_16, _toDisplayString(_ctx.data.address), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        (_ctx.data.isActive)
          ? (_openBlock(), _createBlock(_component_Action, {
              key: 0,
              text: `兑换`,
              onAction: _ctx.submit
            }, null, 8, ["onAction"]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_van_popup, {
        round: "",
        position: "bottom",
        show: _ctx.show,
        "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => (_ctx.show = $event)),
        teleport: ".pop-background"
      }, {
        default: _withId(() => [
          _createVNode(_component_van_area, {
            onConfirm: _ctx.confirmArea,
            onCancel: _ctx.closeArea,
            "area-list": _ctx.areaList
          }, null, 8, ["onConfirm", "onCancel", "area-list"])
        ]),
        _: 1
      }, 8, ["show"])
    ]),
    _: 1
  }))
})